module.exports = __webpack_public_path__ + "img/30m9.f403a0c6.jpg";